import React from "react";
import { Modal, Placeholder } from "rsuite";

const Datenschutz = ({
  openDatenschutz,
  handleCloseDatenschutz,
  backdropDatenschutz,
}) => {
  return (
    <>
      <Modal
        backdrop={backdropDatenschutz}
        keyboard={false}
        open={openDatenschutz}
        onClose={handleCloseDatenschutz}
        backdropClassName="about-swiper-backdrop"
        size={"full"}
        overflow={false}
      >
        <Modal.Header>
          <Modal.Title>Datenschutzerklärung</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* No content, as no future responsibilities are set, yet. */}
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Datenschutz;
